import { render, staticRenderFns } from "./MarkWritingHighBand.vue?vue&type=template&id=72a125a3&scoped=true"
import script from "./MarkWritingHighBand.vue?vue&type=script&lang=js"
export * from "./MarkWritingHighBand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a125a3",
  null
  
)

export default component.exports